import request from '@/utils/request.js'

const baseUrl = process.env.VUE_APP_WORKFLOW_API

// 获取审核流--审批业务
export function getWorkflowBusinessApi() {
  return request({
    url: `${baseUrl}/workflows/approval-businesses/tree`,
    method: 'get'
  })
}

/**
 * 获取审核流业务节点
 * @param businessType
 * @param businessNode
 * @returns {Promise<void>|*}
 */
export function getWorkflowBusinessNodeApi(businessType, businessNode) {
  return request({
    url: `${baseUrl}/workflows/approval-businesses/type/${businessType}/node/${businessNode}/detail`,
    method: 'get'
  })
}

/**
 * 查询审核流定义分页
 * @param params
 * @returns {Promise<void>|*}
 */
export function getWorkflowListApi(params) {
  return request({
    url: `${baseUrl}/workflow-definitions/page`,
    method: 'get',
    params
  })
}

/**
 * 修改工作流定义状态
 * @param data
 * @param definitionId
 * @returns {Promise<void>|*}
 */
export function setWorkflowStatusApi(data, definitionId) {
  return request({
    url: `${baseUrl}/workflow-definitions/${definitionId}/status`,
    method: 'put',
    data
  })
}

/**
 * 新增工作流定义
 * @param data
 * @returns {Promise<void>|*}
 */
export function addWorkflowApi(data) {
  return request({
    url: `${baseUrl}/workflow-definitions`,
    method: 'post',
    data
  })
}

/**
 * 修改工作流的定义
 * @param data
 * @param definitionId
 * @returns {Promise<void>|*}
 */
export function editWorkflowApi(data, definitionId) {
  return request({
    url: `${baseUrl}/workflow-definitions/${definitionId}`,
    method: 'put',
    data
  })
}

/**
 * 获取工作流定义详情
 * @param definitionId
 */
export function getWorkflowDetailApi(definitionId) {
  return request({
    url: `${baseUrl}/workflow-definitions/${definitionId}`,
    method: 'get'
  })
}

/**
 * 查询待办任务-待处理
 * @param params
 * @returns {Promise<void>|*}
 */
export function getWorkflowTodoApi(params) {
  return request({
    url: `${baseUrl}/workflow-tasks/todo/page`,
    method: 'get',
    params
  })
}

/**
 * 查询待办任务-已处理
 * @param params
 * @returns {Promise<void>|*}
 */
export function getWorkflowDoneApi(params) {
  return request({
    url: `${baseUrl}/workflow-tasks/done/page`,
    method: 'get',
    params
  })
}

/**
 * 查询待办任务-已收到
 * @param params
 * @returns {Promise<void>|*}
 */
export function getWorkflowReceivedApi(params) {
  return request({
    url: `${baseUrl}/workflow-tasks/received/page`,
    method: 'get',
    params
  })
}

/**
 * 查询待办任务-已收到
 * @param params
 * @returns {Promise<void>|*}
 */
export function getWorkflowLaunchApi(params) {
  return request({
    url: `${baseUrl}/workflows/launch/page`,
    method: 'get',
    params
  })
}

/**
 * 查询待办任务所属工作流信息
 * @param taskId
 * @returns {Promise<void>|*}
 */
export function getWorkflowAuditWorkflowDetailApi(workflowId) {
  return request({
    url: `${baseUrl}/workflows/${workflowId}`,
    method: 'get'
  })
}

/**
 * 查询待办任务--工作流流程详情
 * @param taskId
 * @returns {Promise<void>|*}
 */
export function getWorkflowAuditProgressDetailApi(workflowId) {
  return request({
    url: `${baseUrl}/workflows/${workflowId}/progress`,
    method: 'get'
  })
}

/**
 * 待办任务详情
 */
export function getWorkflowAuditTaskDetailApi(taskId) {
  return request({
    url: `${baseUrl}/workflow-tasks/${taskId}`,
    method: 'get'
  })
}

/**
 * 待办任务抄送
 */
export function workflowReadApi(taskId) {
  return request({
    url: `${baseUrl}/workflow-tasks/${taskId}/read`,
    method: 'post'
  })
}

/**
 * 待办任务审批
 * @param taskId
 * @returns {Promise<void>|*}
 */
export function getWorkflowAuditSingleReviewApi(taskId, data) {
  return request({
    url: `${baseUrl}/workflow-tasks/${taskId}/review`,
    method: 'post',
    data
  })
}

/**
 * 查询待办任务所属工作流信息
 * @param taskId
 * @returns {Promise<void>|*}
 */
export function auditWorkflowRevekeApi(params, workflowId) {
  return request({
    url: `${baseUrl}/workflows/${workflowId}/cancel`,
    method: 'post',
    params
  })
}

/**
 * 新增备注
 */
export function setWorkflowRemarksApi(data) {
  const { workflowId, ...other } = data
  return request({
    url: `${baseUrl}/workflows/${workflowId}/remarks`,
    method: 'post',
    data: other
  })
}

/**
 * 查询备注列表
 */
export function getWorkflowRemarksApi(workflowId) {
  return request({
    url: `${baseUrl}/workflows/${workflowId}/remarks`,
    method: 'get'
  })
}
